import '../../../../shared/components/ui/Shared.css';
import './Hero.css';

const Hero = ({ onStoreLogin, onStoreRegister }) => (
  <section className="hero">
    <div className="hero-content">
      <h1>Z<span className="brand-q">o</span>pe<span className="brand-q">o</span></h1>
      <p>
        Loyalty infrastructure for physical retail India. Give your customers a reason to return — and actually know when they do.
        <span className="brand-q hero-copy-break">No hidden charges. Flat Fee Subscription.</span>
      </p>
      <div className="hero-actions">
        <button className="btn primary" type="button" onClick={onStoreLogin}>Enterprise Login</button>
        <button className="btn ghost" type="button" onClick={onStoreRegister}>Enterprise Registration</button>
      </div>
    </div>
  </section>
);

export default Hero;
